import { makeAbsenceWarningRepository } from 'shared/infra/repositories';

import ConfirmAbsenceWarningUseCase from './implementations/ConfirmAbsenceWarningUseCase';

let instance: ConfirmAbsenceWarningUseCase | null = null;

export default function makeConfirmAbsenceWarningUseCase() {
  if (!instance) {
    const repository = makeAbsenceWarningRepository();

    instance = new ConfirmAbsenceWarningUseCase(repository);
  }

  return instance;
}
